import Experience from "../Experience.js";
import Environment from "./Environment.js";
import Floor from "./Floor.js";
import Desk from "./Desk.js";
import NorthWall from "./NorthWall.js";
import EasthWall from "./EastWall.js";
import WesthWall from "./WestWall.js";
import Ceiling from "./Ceiling.js";
import Door from "./Door.js";
import Monitor from "./Monitor.js";
import Notebook from "./Notebook.js";
import Keyboard from "./Keyboard.js";
import Mouse from "./Mouse.js";
import Lamp from "./Lamp.js";
import Pencil from "./Pencil.js";
import Plant from "./Plant.js";
import Mug from "./Mug.js";
import LightSwitch from "./LightSwitch.js";
import Window from "./Window.js";
import Notepad from "./Notepad.js";
import TestObject from "./TestObject.js";
import Arcade from "./Arcade.js";

export default class World {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    // Wait for resources
    this.resources.on("ready", () => {
      // Setup
      this.floor = new Floor();
      this.environment = new Environment();
      this.northwall = new NorthWall();
      this.eastwall = new EasthWall();
      this.westwall = new WesthWall();
      this.ceiling = new Ceiling();
      this.desk = new Desk();
      this.door = new Door();
      this.monitor = new Monitor();
      this.notebook = new Notebook();
      this.keyboard = new Keyboard();
      this.mouse = new Mouse();
      this.testObject = new TestObject();
      this.lamp = new Lamp();
      this.pencil = new Pencil();
      this.plant = new Plant();
      this.arcade = new Arcade();
      this.mug = new Mug();
      this.window = new Window();
      this.lightswitch = new LightSwitch();
      this.notepad = new Notepad();
    });
  }

  update(){

    if(this.mug){
      this.mug.update()
    }

  }
}
